import { Instagram, ExternalLink } from "lucide-react";
import { GALLERY_IMAGES, INSTAGRAM } from "../data/mock";
import { useInView } from "../hooks/useInView";

export const PhotoGallery = () => {
  const [ref, isInView] = useInView();
  return (
    <section className="py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-10" ref={ref}>
          <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-sky-600 tracking-wider uppercase mb-4">
            <Instagram className="w-4 h-4" /> Follow us on Instagram
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 tracking-tight mb-4">
            @blitzwashlaundry
          </h2>
          <p className="text-slate-500 mb-6">Peek inside our stores, see before-after transformations, and follow along for laundry tips.</p>
          <a
            href={INSTAGRAM}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-gradient-to-r from-pink-500 via-fuchsia-500 to-orange-400 text-white text-sm font-semibold hover:opacity-90 transition-opacity"
            data-testid="gallery-instagram-btn"
          >
            <Instagram className="w-4 h-4" />
            Follow on Instagram
            <ExternalLink className="w-3.5 h-3.5" />
          </a>
        </div>

        <div className={`grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-3 transition-all duration-700 ${isInView ? "opacity-100" : "opacity-0"}`}>
          {GALLERY_IMAGES.map((img, i) => (
            <a
              key={i}
              href={INSTAGRAM}
              target="_blank"
              rel="noopener noreferrer"
              className="relative aspect-square rounded-2xl overflow-hidden group bg-slate-100"
              data-testid={`gallery-item-${i}`}
              style={{ transitionDelay: `${i * 50}ms` }}
            >
              <img
                src={img.url}
                alt={img.alt}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-3">
                <Instagram className="w-5 h-5 text-white" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
